/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
export default RenderTapAndGo;
export function RenderTapAndGo(state, func, textObj) {
  if (!state || !func) return;

  if (state.loading) {
    return (
      <div className="OrgInfo-emptyPage">
        <div className="OrgInfo-center">
          <div className="OrgInfo-btm-load"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="OrgInfo-contentContainer">
      <div className="OrgInfo-contentHeader">
        <div className="OrgInfo-info">{textObj.title}</div>
      </div>
      <div className="OrgInfo-content" style={{ textAlign: 'center', padding: '60px 20px' }}>
        <div style={{ fontSize: '18pt', color: '#666', marginBottom: '10px' }}>
          Coming Soon
        </div>
        <div style={{ fontSize: '12pt', color: '#999' }}>
          This payment method will be available in a future update.
        </div>
      </div>
    </div>
  );
}
